import { DatePicker, DatePickerProps } from '@mui/x-date-pickers'
import { Controller, FieldValues } from 'react-hook-form'
import { IFormComponent_v2 } from './helper'
import { FormControl, FormLabel, TextField } from '@mui/material'
import DatePickerProvider from '../DatePicker/DatePickerProvider'

interface IFormDatePicker_v2<
    T extends FieldValues,
> extends IFormComponent_v2<T> {
    datePickerProps: DatePickerProps
}

const FormDatePicker_v2 = <T extends FieldValues>({
    control,
    name,
    datePickerProps,
    formLabel,
}: IFormDatePicker_v2<T>) => {
    return (
        <DatePickerProvider>
            <Controller
                control={control}
                name={name}
                render={(props) => (
                    <FormControl error={Boolean(props.fieldState.error)}>
                    {!!formLabel ? (
                        <FormLabel sx={{ mb: 1.5 }}>{formLabel}</FormLabel>
                    ) : null}
                    <DatePicker
                        {...datePickerProps}
                        value={props.field.value || null}
                        onChange={props.field.onChange}
                        enableAccessibleFieldDOMStructure={false}
                        slots={{
                            ...datePickerProps.slots,
                            textField: TextField,
                        }}
                        slotProps={{
                            ...datePickerProps.slotProps,
                            textField: {
                                ...datePickerProps.slotProps?.textField,
                                error: !!props.fieldState.error,
                                helperText: props.fieldState.error?.message,
                            },
                        }}
                    />
                    </FormControl>
                )}
            />
        </DatePickerProvider>
    )
}

export default FormDatePicker_v2
